let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ia9tz")).then(() => parcelRequire('d32ti'));